import { inject, Injectable } from '@angular/core';
import { AuthProvider, AuthType } from '@nx-customer-apps/components';
import { OAuthService } from 'angular-oauth2-oidc';
import { LanguageSwitcherService } from './language-switcher.service';

@Injectable()
export class RoomByRoomAuthProvider implements AuthProvider {
    private languageSwitcherService = inject(LanguageSwitcherService);
    private oauth = inject(OAuthService);

    public getType(): AuthType {
        return AuthType.IAM_Token;
    }

    public getToken(): string {
        return this.oauth.getAccessToken();
    }

    public getCountryCode(): string {
        return this.languageSwitcherService.getCountryCode();
    }

    public getLanguageCode(): string {
        return this.languageSwitcherService.getLanguageCode();
    }
}
